import { render, staticRenderFns } from "./CustomEmail.vue?vue&type=template&id=7dd6961a&scoped=true&"
import script from "./CustomEmail.vue?vue&type=script&lang=js&"
export * from "./CustomEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6961a",
  null
  
)

export default component.exports